import { useState } from "react";
import { BiSolidBadgeCheck } from "react-icons/bi";
import Dialog from "src/components/layout/Dialog/Dialog";
import Linkify from "linkify-react";
import styles from "src/components/elements/CertificationMark/certificationMark.module.css";
import baseStyles from "src/global.module.css";

const CertificationMark: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    const openDialog = () => {
        setIsOpen(true);
    };

    return (
        <>
            <div
                onClick={(e) => {
                    e.stopPropagation();
                    openDialog();
                }}
                onKeyDown={openDialog}
                role="button"
                tabIndex={0}
                aria-label="公認マークの説明を見る"
            >
                <BiSolidBadgeCheck size="1.3rem" color="#4a43ec" />
            </div>
            <Dialog
                isOpen={isOpen}
                title="KOBEまちなかパフォーマンス公認マーク"
                content={
                    <Linkify
                        options={{
                            nl2br: true,
                            className: `${baseStyles.link_text}`,
                        }}
                    >
                        <div className={styles.tooltip_text}>
                            <p className={styles.tooltip_text}>
                                このアーティストはKOBEまちなかパフォーマンスの登録アーティストです。
                            </p>
                            <br />
                            <p className={styles.tooltip_text}>
                                まちなかパフォーマンスについての詳細な情報は以下のリンクから確認できます↓
                            </p>
                            <br />
                            <p className={styles.tooltip_text}>
                                https://www.kobe-bunka.jp/machinaka/
                            </p>
                        </div>
                    </Linkify>
                }
                onNo={{
                    onClick: () => {
                        setIsOpen(false);
                    },
                    label: "閉じる",
                }}
                handleClose={() => {
                    setIsOpen(false);
                }}
            />
        </>
    );
};

export default CertificationMark;
